import { Component } from '@angular/core';

@Component({
  selector: 'app-gestion-evaluation',
  templateUrl: './gestion-evaluation.component.html',
  styleUrl: './gestion-evaluation.component.css'
})
export class GestionEvaluationComponent {

}
